import { render } from "./BillingRuns.vue?vue&type=template&id=2fd50116&scoped=true"
import script from "./BillingRuns.vue?vue&type=script&lang=js"
export * from "./BillingRuns.vue?vue&type=script&lang=js"

import "./BillingRuns.vue?vue&type=style&index=0&id=2fd50116&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd50116"]])

export default __exports__